import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "1.jpg",
        title: "FAQ",
        crumb: "FAQ"
    },
    faq: {
        title: "FAQ's",
        subtitle: "Frequently Ask Questions?",
        description: "Here are some frequently asked questions to help you better understand Source Huts and the services we offer.",
        faqs: [
            {
                que: "What is Source Huts, and what services do you offer?",
                ans: "Source Huts is a comprehensive service provider specializing in product sourcing, factory audits, product inspections, sample evaluations, and photography/videography. We ensure that your supply chain is efficient, cost-effective, and reliable while maintaining the highest quality standards."
            },
            {
                que: "How does Source Huts help with product sourcing?",
                ans: "We connect you with trusted manufacturers and suppliers, ensuring the best quality and competitive pricing for your products. Our team performs due diligence on suppliers to minimize risks and streamline your procurement process."
            },
            {
                que: "What is a factory audit, and why is it important?",
                ans: "A factory audit evaluates a supplier's capabilities, production processes, quality control, and compliance with international standards. It helps you ensure that your supplier can meet your expectations and deliver consistently high-quality products."
            },
            {
                que: "How do you conduct product inspections?",
                ans: "We conduct product inspections at different stages of production, such as pre-production, in-line, and pre-shipment inspections. Our team checks for quality, compliance with specifications, and overall product integrity to ensure you receive what you ordered."
            },
            {
                que: "What is a sample evaluation, and how can it benefit my business?",
                ans: "Sample evaluation involves reviewing product samples to assess quality, design, and functionality before placing a bulk order. This helps you make informed decisions and reduces the risk of receiving substandard goods."
            },
            {
                que: " Do you provide photography and videography services for products?",
                ans: "Yes, we offer professional photography and videography services to showcase your products effectively. Our team captures high-quality visuals that highlight your product’s features, making them stand out in marketing campaigns or e-commerce platforms."
            },
            {
                que: " Can you help me find suppliers for niche products?",
                ans: "Absolutely! Our team has extensive experience in sourcing unique and niche products. Share your requirements with us, and we will find the right supplier for your specific needs."
            },
            {
                que: "Are your services available globally?",
                ans: "Yes, Source Huts operates globally. We have an extensive network of suppliers and service providers across various regions to support your business needs, regardless of location."
            },
            {
                que: "How do you ensure the suppliers you work with are trustworthy?",
                ans: "We conduct thorough background checks, including factory audits, compliance verification, and references, to ensure the reliability of suppliers. Our team follows strict quality control measures to safeguard your interests."
            },
            {
                que: "How can I get started with Source Huts?",
                ans: "Getting started is simple! Contact us through our website or email with your requirements. Our team will assess your needs and provide tailored solutions to help your business succeed."
            }
        ]
    }
}